import { render, staticRenderFns } from "./ImportSoloCodigos.vue?vue&type=template&id=b0c70520&scoped=true"
import script from "./ImportSoloCodigos.vue?vue&type=script&lang=js"
export * from "./ImportSoloCodigos.vue?vue&type=script&lang=js"
import style0 from "./ImportSoloCodigos.vue?vue&type=style&index=0&id=b0c70520&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0c70520",
  null
  
)

export default component.exports